import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { SeFeTranslationsLoader } from 'se-fe-translations'

import {
  OpenRegistrationFilterComponent,
  OpenRegistrationFilterOption,
  OpenRegistrationFilters,
} from '../open-registration-filter/open-registration-filter.component'

@Component({
  selector: 'se-po-open-registration-search',
  templateUrl: './open-registration-search.component.html',
  styleUrls: ['./open-registration-search.component.scss'],
  standalone: false,
})
export class OpenRegistrationSearchComponent implements OnChanges, OnInit {
  public readonly translationKey =
    'SE_PO_SE_REGISTRATION_UI_FEATURE_OPEN_REGISTRATION_LIST.'
  private readonly translationsPath =
    'se-registration-ui/feature-open-registration-list/assets/translations'

  @Input() public clearFiltersRequestId = 0
  @Input() public sports: OpenRegistrationFilterOption[] = []
  @Input() public signupTypeList: OpenRegistrationFilterOption[] = []
  @Input() public organizations: OpenRegistrationFilterOption[] = []

  @Output() public searchTermChange = new EventEmitter<string>()
  @Output() public filtersChange = new EventEmitter<OpenRegistrationFilters>()
  @Output() public filtersCleared = new EventEmitter<void>()

  @ViewChild(OpenRegistrationFilterComponent)
  private filterComponent?: OpenRegistrationFilterComponent

  public searchTerm = ''
  public translationsLoaded = false

  constructor(private translationsLoader: SeFeTranslationsLoader) {}

  public ngOnChanges(changes: SimpleChanges): void {
    const clearFiltersRequest = changes.clearFiltersRequestId
    if (!clearFiltersRequest || clearFiltersRequest.firstChange) return

    this.clearFilters()
  }

  public ngOnInit(): void {
    void this.loadTranslations()
  }

  public handleSearchQueryChange(searchTerm: string): void {
    this.searchTerm = searchTerm
    this.searchTermChange.emit(searchTerm)
  }

  public handleFiltersChange(filters: OpenRegistrationFilters): void {
    this.filtersChange.emit(filters)
  }

  public clearFilters(): void {
    this.searchTerm = ''
    this.filterComponent?.clearAllFilters(false)
    this.filtersCleared.emit()
  }

  private async loadTranslations(): Promise<void> {
    this.translationsLoaded = await this.translationsLoader.load(this.translationsPath)
  }
}
